import React from "react"
import { BaseButton, ErrorBoundary, Grid } from "@cd2/components"
import { buttonConfigs } from "../constants/buttonConfigs"
import { TextGroupMedium } from "@cd2/components/build/es6"

export function ErrorBoundaryInModal({
  children,
  onClose,
}: {
  children: React.ReactNode
  onClose: () => void
}) {
  return (
    <ErrorBoundary
      ErrorComponent={() => (
        <Grid gap={16}>
          <TextGroupMedium
            heading={"An error has occurred"}
            body={"Please try again or contact support"}
          />
          <div>
            <BaseButton {...buttonConfigs.generalNight} onClick={onClose}>
              Close
            </BaseButton>
          </div>
        </Grid>
      )}
    >
      {children}
    </ErrorBoundary>
  )
}
